<template>
  <div>
    <section class="top">
      <div class="header">
        <div class="header-svg clouds"></div>
        <div class="container">
          <div class="columns">
            <div class="column is-6">
              <h1 class="title is-1 mb-6 has-text-left" ref="logo">{{ post.title }}</h1>
            </div>
            <div class="column is-6 has-text-centered">
              <img class="image-200" src="../../assets/undraw/post.svg">
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <span class="content" v-html="post.content"></span>
    </div>
  </div>
</template>
<script>
import ApiService from "@/common/api.service"
import router from "@/router"
import moment from "moment"
import showdown from "showdown"

const converter = new showdown.Converter({ simpleLineBreaks: true })

export default {
  props: ["id"],
  data() {
    return {
      post: {}
    }
  },
  mounted() {
    this.getPosts()
  },
  methods: {
    async getPosts() {
      let response = await ApiService.get("https://blog.ikleeralles.nl/blogposts/" + this.id, true, false)
      this.post = response.data
      this.post.content = converter.makeHtml(this.post.content)
    },
    format(sqldate) {
      return moment(sqldate)
        .lang("nl")
        .fromNow()
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 20px;
}
.content {
  p {
    padding-bottom: 20px !important;
  }
}

.header {
  background: #1d73f4;
  padding: 50px 0;
  .logo {
    max-width: 40%;
  }
  .title,
  .subtitle {
    color: #fff;
  }
  .header-svg {
    position: absolute;
    &.clouds {
      top: 0;
      width: 100%;
      height: 100%;
      background: url("~@/assets/header-clouds.svg");
    }
  }
}

.image-200 {
  max-height: 200px;
}
</style>
